import { render, staticRenderFns } from "./CrmFollowUps.vue?vue&type=template&id=4b4ccef8&scoped=true"
import script from "./CrmFollowUps.vue?vue&type=script&lang=js"
export * from "./CrmFollowUps.vue?vue&type=script&lang=js"
import style0 from "./CrmFollowUps.vue?vue&type=style&index=0&id=4b4ccef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ccef8",
  null
  
)

export default component.exports